import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { selectUserProfile } from '../../../../common/category/store/slice'
import { Element } from '../../../../common/html/element'
import { formatText } from '../../../../helpers/value'
import { selectUserType } from '../../../../layout/store/slice'
import { selectNumberOfCompany } from '../../../../tool/screening/exportFileSetting/store/slice'
import { PopupBuyNow } from '../../../../userManagement/subscriptionPayment/common/popupBuyNow'
import { PopupBuyPackage } from '../../../../userManagement/subscriptionPayment/common/popupBuyPackage'
import { USER_TYPE } from '../../../../utils/authorization'
import { IDS_REPORT, PAYMENT_METHOD } from '../../../constant'
import { convertDataTablePackage } from '../../../helper'
import classes from '../../../index.module.scss'
import {
  changeDisableOrder,
  selectDataByTypeReport,
  selectUserPackage,
} from '../../../store/slice'

export const Package = ({
  isScreening,
  dataReportUserManagement,
  setDisablePackage,
  isShowInvalid,
  isShowNotFullDataBlock = false,
  isBothFullAndNotFullDataBlock = false,
}) => {
  const dispatch = useDispatch()

  const [isDisable, setDisable] = useState(false)

  const userProfile = useSelector(selectUserProfile)
  const userType = useSelector(selectUserType)

  const dataPackage = useSelector(selectUserPackage)
  const dataByTypeReport = useSelector(selectDataByTypeReport)
  const numberCompany = useSelector(selectNumberOfCompany)
  const screeningType = {
    ...dataByTypeReport,
    [IDS_REPORT.SCREENING]: [...new Array(Number(numberCompany))],
  }

  const arrPackage = convertDataTablePackage(
    dataPackage,
    dataReportUserManagement
      ? dataReportUserManagement
      : isScreening
      ? screeningType
      : dataByTypeReport,
  )

  useEffect(() => {
    if (isDisable) {
      dispatch(
        changeDisableOrder({
          [PAYMENT_METHOD.PACKAGE]: true,
        }),
      )
      setDisablePackage && setDisablePackage(true)
    }
    return () => {
      dispatch(
        changeDisableOrder({
          [PAYMENT_METHOD.PACKAGE]: false,
        }),
      )
    }
  }, [isDisable])

  return (
    <div className="wh100">
      {isShowNotFullDataBlock &&
        ![USER_TYPE.PREMIUM, USER_TYPE.STANDARD].includes(
          userType.userTypeId,
        ) && (
          <>
            <Element className="pb1" style={{ color: '#9C9C9C' }}>
              <Translate
                value={`cartAndOrders.message.${
                  isBothFullAndNotFullDataBlock ? 'm22' : 'm12'
                }`}
              />
            </Element>
          </>
        )}
      <Element
        style={{ backgroundColor: '#FFFFFF', border: '1px solid #D5D5D5' }}
      >
        <table className={classes.tablePayment}>
          <thead>
            <tr>
              <td>
                <Translate value="cartAndOrders.main.reportType" />/
                <br />
                <Translate value="cartAndOrders.main.service" />
              </td>
              <td>
                <Translate value="cartAndOrders.main.currentBalance" />
              </td>
              <td>
                <Translate value="cartAndOrders.main.orderedNumber" />
              </td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            {arrPackage.map((item) => (
              <TrTable
                item={item}
                key={item.name}
                setDisable={setDisable}
                userProfile={userProfile}
                isShowNotFullDataBlock={
                  isShowNotFullDataBlock &&
                  ![USER_TYPE.PREMIUM, USER_TYPE.STANDARD].includes(
                    userType.userTypeId,
                  )
                }
              />
            ))}
          </tbody>
        </table>
      </Element>
      {isShowInvalid && isDisable && (
        <Element
          className="pt1"
          style={{
            color: '#E0505B',
          }}
        >
          <Translate value="cartAndOrders.main.textInvalidPackage" />
        </Element>
      )}
    </div>
  )
}

export const TrTable = ({
  item,
  setDisable,
  userProfile,
  isShowNotFullDataBlock,
}) => {
  const [isOpenBuyPackage, setIsOpenBuyPackage] = useState(false)

  const isActive = !!item.orderedNumber && !isShowNotFullDataBlock
  const isHightLight =
    (Number(item.orderedNumber) > Number(item.currentBalance) ||
      !item.currentBalance) &&
    isActive &&
    !isShowNotFullDataBlock

  const [isOpenBuyNow, setIsOpenBuyNow] = useState(false)

  const openBuyPackage = () => {
    setIsOpenBuyPackage(true)
  }

  useEffect(() => {
    if (isHightLight) {
      setDisable(true)
    }
  }, [])

  return (
    <Element
      elementName="tr"
      style={{
        backgroundColor: isActive ? '#C8E3FF' : '',
      }}
    >
      <td>{item.name}</td>
      <td
        style={{
          color: isHightLight ? '#E0505B' : '',
        }}
      >
        {item.currentBalance ?? formatText(item.currentBalance)}
      </td>
      <td
        style={{
          color: isHightLight ? '#E0505B' : '',
        }}
      >
        {item.orderedNumber}
      </td>
      <td>
        <Element
          className="cursorPointer whiteSpaceNowrap"
          style={{ color: '#2C73E8' }}
          onClick={openBuyPackage}
        >
          <Translate value="cartAndOrders.main.buyPackage" />
        </Element>
      </td>
      {isOpenBuyPackage && (
        <PopupBuyPackage
          isShow={isOpenBuyPackage}
          setIsShow={setIsOpenBuyPackage}
          defaultReportId={item.id}
          setIsOpenBuyNow={setIsOpenBuyNow}
          userProfile={userProfile}
        />
      )}

      {isOpenBuyNow && (
        <PopupBuyNow
          isShow={isOpenBuyNow}
          setIsShow={setIsOpenBuyNow}
          userProfile={userProfile}
          isBuyPackage
        />
      )}
    </Element>
  )
}
